import { ResourceType } from 'features/common/types'
import { checkMapAccessPermissions, checkWorkflowAccessPermissions } from '../api/authRedirect'

const key = 'auth-redirect'

function useAuthRedirectQueries(resource: ResourceType, id) {
  const queries = {
    checkMapAccess: {
      queryKey: [key, ResourceType.Map, id],
      queryFn: () => checkMapAccessPermissions(id),
      staleTime: Infinity,
      enabled: Boolean(id)
    },
    checkWorkflowAccess: {
      queryKey: [key, ResourceType.Map, id],
      queryFn: () => checkWorkflowAccessPermissions(id),
      staleTime: Infinity,
      enabled: Boolean(id)
    }
  }

  return { queries }
}

export default useAuthRedirectQueries
